const s = {
  name: "CodeDeveloperTools",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,2h35V0H0V2z"/>
		<path class="st0" d="M5,38h16v-2H5V38z"/>
		<path class="st0" d="M40,14H0v-2h40V14z"/>
		<path class="st0" d="M0,26h21v-2H0V26z"/>
		<path class="st0" d="M11,8H0V6h11V8z"/>
		<path class="st0" d="M19,8h21V6H19V8z"/>
		<path class="st0" d="M16,32H0v-2h16V32z"/>
		<path class="st0" d="M14,8h2V6h-2V8z"/>
		<path class="st0" d="M21,32h-2v-2h2V32z"/>
		<path class="st0" d="M38,2h2V0h-2V2z"/>
		<path class="st0" d="M2,38H0v-2h2V38z"/>
		<path class="st0" d="M38,20h2v-2h-2V20z"/>
		<path class="st0" d="M21,20h-2v-2h2V20z"/>
		<path class="st0" d="M0,20h2v-2H0V20z"/>
		<path class="st0" d="M16,20H5v-2h11V20z"/>
		<path class="st0" d="M24,20h11v-2H24V20z"/>
		<path class="st0" d="M32,27c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C35,28.3,33.7,27,32,27z M31,30c0-0.6,0.4-1,1-1
			s1,0.4,1,1c0,0.6-0.4,1-1,1S31,30.6,31,30z"/>
		<path class="st0" d="M30.8,22.1l0.4,0.5c0.2,0.2,0.5,0.4,0.8,0.4s0.6-0.2,0.8-0.4l0.4-0.5l0.6,0.1c1.6,0.4,3,1.2,4,2.3l0.5,0.5
			L38,25.6c-0.1,0.3-0.1,0.6,0.1,0.9c0.2,0.3,0.4,0.5,0.7,0.5l0.7,0.1l0.2,0.6c0.2,0.7,0.3,1.5,0.3,2.3c0,0.8-0.1,1.6-0.3,2.3
			l-0.2,0.6L38.8,33c-0.3,0-0.6,0.2-0.7,0.5c-0.2,0.3-0.2,0.6-0.1,0.9l0.3,0.6l-0.5,0.5c-1.1,1.1-2.4,2-4,2.3l-0.6,0.1l-0.4-0.5
			C32.6,37.2,32.3,37,32,37s-0.6,0.2-0.8,0.4l-0.4,0.5l-0.6-0.1c-1.6-0.4-3-1.2-4-2.3L25.7,35l0.3-0.6c0.1-0.3,0.1-0.6-0.1-0.9
			c-0.2-0.3-0.4-0.5-0.7-0.5l-0.7-0.1l-0.2-0.6C24.1,31.6,24,30.8,24,30c0-0.8,0.1-1.6,0.3-2.3l0.2-0.6l0.7-0.1
			c0.3,0,0.6-0.2,0.7-0.5c0.2-0.3,0.2-0.6,0.1-0.9L25.7,25l0.5-0.5c1.1-1.1,2.4-2,4-2.3L30.8,22.1z M28,25.5c0.1,0.7,0,1.4-0.4,2
			c-0.4,0.6-0.9,1.1-1.6,1.3C26,29.2,26,29.6,26,30c0,0.4,0,0.8,0.1,1.2c0.6,0.2,1.2,0.7,1.6,1.3c0.4,0.6,0.5,1.3,0.4,2
			c0.6,0.5,1.3,0.9,2.1,1.2c0.5-0.4,1.2-0.7,1.9-0.7s1.4,0.3,1.9,0.7c0.8-0.3,1.5-0.7,2.1-1.2c-0.1-0.7,0-1.4,0.4-2
			c0.4-0.6,0.9-1.1,1.6-1.3C38,30.8,38,30.4,38,30c0-0.4,0-0.8-0.1-1.2c-0.6-0.2-1.2-0.7-1.6-1.3c-0.4-0.6-0.5-1.3-0.4-2
			c-0.6-0.5-1.3-0.9-2.1-1.2C33.4,24.7,32.7,25,32,25s-1.4-0.3-1.9-0.7C29.3,24.6,28.6,25,28,25.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CodeDeveloperTools
};
